import { withMotionMax } from '@hoc/withMotionMax';
import useScrollLock from '@hooks/useBodyScrollLock';
import { LinkButton, default as Button } from '@stories/Components/Buttons/GeneralButton/Button';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import SearchField from '@stories/Components/Header/SearchField/SearchField';
import Navigation from '@stories/Components/Navigation/Navigation';
import NavigationMobile from '@stories/Components/Navigation/NavigationMobile/NavigationMobile';
import { useReducedMotion } from 'framer-motion';
import React, { useState } from 'react';
import HeaderStyles from './Header.styles';
const Header = ({ logo, isHomePage, h1Text, navigation = [], popularSearchTerms, rentalHomeCta, sageHomeCta = undefined, searchResultsUrl = '/', searchResultsPlaceholder = 'Enter Search Term', transparent = true, }) => {
    const ref = React.useRef(null);
    const [showSearch, setShowSearch] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const [activeMobileNavigationId, setActiveMobileNavigationId] = useState('');
    useScrollLock(ref.current, openMenu || showSearch);
    const shouldReduceMotion = useReducedMotion();
    return (React.createElement(React.Fragment, null,
        React.createElement(HeaderStyles.Container, { "data-transparent": transparent },
            React.createElement(HeaderStyles.AccessibilityBar, null,
                React.createElement(Button, { branding: "secondary", title: "Accessibility Tools", size: "small", onClick: (e) => {
                        e.preventDefault;
                        // @ts-ignore - recite.me external function (https://knowledge.reciteme.com/knowledge/html)
                        window?.['loadService']();
                    } })),
            React.createElement(SiteWide, null,
                React.createElement(HeaderStyles.Grid, null,
                    React.createElement(HeaderStyles.LogoArea, null,
                        isHomePage && h1Text && logo && (React.createElement("h1", null,
                            React.createElement(HeaderStyles.HomeLink, { href: logo.url, "aria-label": h1Text },
                                React.createElement(HeaderStyles.Logo, { alt: h1Text, loading: "lazy", src: logo.src })))),
                        !isHomePage && logo && (React.createElement(HeaderStyles.HomeLink, { href: logo.url, "aria-label": "Home" },
                            React.createElement(HeaderStyles.Logo, { alt: logo.title, loading: "lazy", src: logo.src })))),
                    React.createElement(HeaderStyles.ButtonHolder, null,
                        searchResultsUrl && (React.createElement(HeaderStyles.SearchArea, null,
                            React.createElement(HeaderStyles.ShowSearch, { type: "button", onClick: () => setShowSearch(true), "aria-label": "Open Search" },
                                React.createElement(HeaderStyles.SearchIcon, null)))),
                        React.createElement(HeaderStyles.CtaArea, null,
                            React.createElement(HeaderStyles.CtaMobileInner, null,
                                React.createElement(HeaderStyles.CtaHolder, null, sageHomeCta && sageHomeCta?.url && (React.createElement(HeaderStyles.UserIconButton, { onClick: () => window.location.href = `${sageHomeCta?.url}`, role: "navigation", title: sageHomeCta?.text },
                                    React.createElement(HeaderStyles.UserIcon, null))))),
                            React.createElement(HeaderStyles.CtaInner, null,
                                React.createElement(HeaderStyles.CtaHolder, null,
                                    sageHomeCta && sageHomeCta?.url && (React.createElement(LinkButton, { branding: sageHomeCta?.branding ?? 'primary', title: sageHomeCta?.text ?? '', href: sageHomeCta?.url, target: sageHomeCta?.target })),
                                    rentalHomeCta && rentalHomeCta?.url && (React.createElement(LinkButton, { branding: rentalHomeCta?.branding ?? 'primary', title: rentalHomeCta?.text ?? '', href: rentalHomeCta?.url, target: rentalHomeCta?.target })))),
                            React.createElement(HeaderStyles.MobileMenuBtn, { type: "button", openMenu: openMenu, onClick: () => setOpenMenu(!openMenu), role: "navigation", title: !openMenu ? "Open menu" : "Close menu" },
                                !openMenu && React.createElement(HeaderStyles.MenuIcon, null),
                                openMenu && React.createElement(HeaderStyles.CloseIcon, null)))))),
            React.createElement(Navigation, { items: navigation }),
            React.createElement(HeaderStyles.MobileNavHolder, { ref: ref, active: openMenu, initial: 'hidden', animate: openMenu ? 'visible' : 'hidden', variants: shouldReduceMotion
                    ? {
                        hidden: {
                            opacity: 0,
                            transitionEnd: {
                                visibility: 'hidden',
                            },
                        },
                        visible: {
                            opacity: 1,
                            visibility: 'visible',
                        },
                    }
                    : {
                        hidden: {
                            opacity: 0,
                            x: '-100%',
                            transitionEnd: {
                                visibility: 'hidden',
                            },
                        },
                        visible: {
                            opacity: 1,
                            visibility: 'visible',
                            x: '0',
                        },
                    }, transition: {
                    type: 'tween',
                    ease: [0.45, 0.01, 0.1, 1],
                } },
                React.createElement(NavigationMobile, { activeId: activeMobileNavigationId, items: navigation, sageHomeCta: sageHomeCta, onItemClick: (id) => setActiveMobileNavigationId(id), rentalHomeCta: rentalHomeCta }))),
        React.createElement(SearchField, { popularSearchTerms: popularSearchTerms, searchResultsUrl: searchResultsUrl, searchResultsPlaceholder: searchResultsPlaceholder, showSearch: showSearch, onClose: () => setShowSearch(false) })));
};
export default withMotionMax(Header);
